import ModuleBase from '../shared/ModuleBase.js';

/**
 * Accordion — Toggle fuer AccordionContainer Content Elements
 * Jeder Container hat einen Button (trigger) und eine Region (content)
 * Template nutzt data-state="open"/"closed" fuer Zustandssteuerung
 */
export default class Accordion extends ModuleBase {
    constructor(el) {
        super(el);
        this._animating = false;
        this._init();
    }

    _init() {
        this._trigger = this.$el.querySelector('button[type="button"][aria-controls]');
        this._content = this.$el.querySelector('[role="region"]');
        if (!this._trigger || !this._content) return;

        this._trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this._toggle();
        });
    }

    _toggle() {
        if (this._animating) return;

        const isOpen = this._trigger.getAttribute('data-state') === 'open';
        if (isOpen) {
            this._close();
        } else {
            this._open();
        }
    }

    _open() {
        this._animating = true;

        this._trigger.setAttribute('aria-expanded', 'true');
        this._trigger.setAttribute('data-state', 'open');
        this._content.setAttribute('data-state', 'open');
        this._trigger.closest('[data-state]').setAttribute('data-state', 'open');

        this._content.removeAttribute('hidden');
        this._content.style.display = '';
        this._content.style.overflow = 'hidden';
        this._content.style.height = '0px';
        this._content.style.transition = 'height 0.4s ease';

        requestAnimationFrame(() => {
            this._content.style.height = this._content.scrollHeight + 'px';
        });

        setTimeout(() => {
            this._content.style.height = 'auto';
            this._content.style.overflow = '';
            this._content.style.transition = '';
            this._animating = false;
        }, 400);
    }

    _close() {
        this._animating = true;

        this._trigger.setAttribute('aria-expanded', 'false');
        this._trigger.setAttribute('data-state', 'closed');
        this._content.setAttribute('data-state', 'closed');
        this._trigger.closest('[data-state]').setAttribute('data-state', 'closed');

        const currentHeight = this._content.offsetHeight;
        this._content.style.overflow = 'hidden';
        this._content.style.height = currentHeight + 'px';
        this._content.style.transition = 'height 0.4s ease';

        requestAnimationFrame(() => {
            this._content.style.height = '0px';
        });

        setTimeout(() => {
            this._content.style.display = 'none';
            this._content.style.height = '';
            this._content.style.overflow = '';
            this._content.style.transition = '';
            this._content.setAttribute('hidden', '');
            this._animating = false;
        }, 400);
    }
}
